/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Posts_Releasedate1Inputs */

const id_misc_posts_releasedate1 = /** @type {(inputs: Misc_Posts_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`April 2022`)
};

const ms_misc_posts_releasedate1 = /** @type {(inputs: Misc_Posts_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`April 2022`)
};

const da_misc_posts_releasedate1 = /** @type {(inputs: Misc_Posts_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`April 2022`)
};

const de_misc_posts_releasedate1 = /** @type {(inputs: Misc_Posts_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`April 2022`)
};

const en_us2_misc_posts_releasedate1 = /** @type {(inputs: Misc_Posts_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`April 2022`)
};

const es_es2_misc_posts_releasedate1 = /** @type {(inputs: Misc_Posts_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`abril de 2022`)
};

const es_mx2_misc_posts_releasedate1 = /** @type {(inputs: Misc_Posts_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`abril de 2022`)
};

const fil_misc_posts_releasedate1 = /** @type {(inputs: Misc_Posts_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abril 2022`)
};

const fr_misc_posts_releasedate1 = /** @type {(inputs: Misc_Posts_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`avril 2022`)
};

const it_misc_posts_releasedate1 = /** @type {(inputs: Misc_Posts_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aprile 2022`)
};

const hu_misc_posts_releasedate1 = /** @type {(inputs: Misc_Posts_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2022. április`)
};

const nl_misc_posts_releasedate1 = /** @type {(inputs: Misc_Posts_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`april 2022`)
};

const no_misc_posts_releasedate1 = /** @type {(inputs: Misc_Posts_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`april 2022`)
};

const pl_misc_posts_releasedate1 = /** @type {(inputs: Misc_Posts_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kwiecień 2022`)
};

const pt_br2_misc_posts_releasedate1 = /** @type {(inputs: Misc_Posts_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abril de 2022`)
};

const pt_misc_posts_releasedate1 = /** @type {(inputs: Misc_Posts_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`abril de 2022`)
};

const ro_misc_posts_releasedate1 = /** @type {(inputs: Misc_Posts_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aprilie 2022`)
};

const fi_misc_posts_releasedate1 = /** @type {(inputs: Misc_Posts_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`huhtikuussa 2022`)
};

const sv_misc_posts_releasedate1 = /** @type {(inputs: Misc_Posts_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`april 2022`)
};

const vi_misc_posts_releasedate1 = /** @type {(inputs: Misc_Posts_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tháng 4 năm 2022`)
};

const tr_misc_posts_releasedate1 = /** @type {(inputs: Misc_Posts_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nisan 2022`)
};

const cs_misc_posts_releasedate1 = /** @type {(inputs: Misc_Posts_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dubnu 2022`)
};

const bg_misc_posts_releasedate1 = /** @type {(inputs: Misc_Posts_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`април 2022 г.`)
};

const ru_misc_posts_releasedate1 = /** @type {(inputs: Misc_Posts_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`апреле 2022 г.`)
};

const uk_misc_posts_releasedate1 = /** @type {(inputs: Misc_Posts_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`квітень 2022 р.`)
};

const ar_misc_posts_releasedate1 = /** @type {(inputs: Misc_Posts_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أبريل 2022`)
};

const hi_misc_posts_releasedate1 = /** @type {(inputs: Misc_Posts_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अप्रैल 2022`)
};

const th_misc_posts_releasedate1 = /** @type {(inputs: Misc_Posts_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เมษายน 2022`)
};

const ja_misc_posts_releasedate1 = /** @type {(inputs: Misc_Posts_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2022年4月`)
};

const zh_cn2_misc_posts_releasedate1 = /** @type {(inputs: Misc_Posts_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2022年4月`)
};

const zh_hant1_misc_posts_releasedate1 = /** @type {(inputs: Misc_Posts_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2022年4月`)
};

const ko_misc_posts_releasedate1 = /** @type {(inputs: Misc_Posts_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2022년 4월`)
};

/**
* | output |
* | --- |
* | "April 2022" |
*
* @param {Misc_Posts_Releasedate1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_posts_releasedate1 = /** @type {((inputs?: Misc_Posts_Releasedate1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Posts_Releasedate1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_posts_releasedate1(inputs)
	if (locale === "ms") return ms_misc_posts_releasedate1(inputs)
	if (locale === "da") return da_misc_posts_releasedate1(inputs)
	if (locale === "de") return de_misc_posts_releasedate1(inputs)
	if (locale === "en-US") return en_us2_misc_posts_releasedate1(inputs)
	if (locale === "es-ES") return es_es2_misc_posts_releasedate1(inputs)
	if (locale === "es-MX") return es_mx2_misc_posts_releasedate1(inputs)
	if (locale === "fil") return fil_misc_posts_releasedate1(inputs)
	if (locale === "fr") return fr_misc_posts_releasedate1(inputs)
	if (locale === "it") return it_misc_posts_releasedate1(inputs)
	if (locale === "hu") return hu_misc_posts_releasedate1(inputs)
	if (locale === "nl") return nl_misc_posts_releasedate1(inputs)
	if (locale === "no") return no_misc_posts_releasedate1(inputs)
	if (locale === "pl") return pl_misc_posts_releasedate1(inputs)
	if (locale === "pt-BR") return pt_br2_misc_posts_releasedate1(inputs)
	if (locale === "pt") return pt_misc_posts_releasedate1(inputs)
	if (locale === "ro") return ro_misc_posts_releasedate1(inputs)
	if (locale === "fi") return fi_misc_posts_releasedate1(inputs)
	if (locale === "sv") return sv_misc_posts_releasedate1(inputs)
	if (locale === "vi") return vi_misc_posts_releasedate1(inputs)
	if (locale === "tr") return tr_misc_posts_releasedate1(inputs)
	if (locale === "cs") return cs_misc_posts_releasedate1(inputs)
	if (locale === "bg") return bg_misc_posts_releasedate1(inputs)
	if (locale === "ru") return ru_misc_posts_releasedate1(inputs)
	if (locale === "uk") return uk_misc_posts_releasedate1(inputs)
	if (locale === "ar") return ar_misc_posts_releasedate1(inputs)
	if (locale === "hi") return hi_misc_posts_releasedate1(inputs)
	if (locale === "th") return th_misc_posts_releasedate1(inputs)
	if (locale === "ja") return ja_misc_posts_releasedate1(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_posts_releasedate1(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_posts_releasedate1(inputs)
	return ko_misc_posts_releasedate1(inputs)
});
export { misc_posts_releasedate1 as "misc.posts.releaseDate" }